import * as React from 'react';
import { FacebookIcon, LinkedInIcon } from '../icons';
import styles from './FollowUs.module.scss';
import { AnalyticsConsumer } from '../../providers/AnalyticsProvider';

const FollowUs = () => (
  <section className={styles.root}>
    <AnalyticsConsumer category="social_media">
      {({ sendAction, dataProps }) => (
        <div className={styles.holder}>
          <p className={styles.caption}>Follow us</p>
          <div className={styles.linkHolder}>
            <a
              className={styles.link}
              href="https://www.linkedin.com/company/flatfycom/about"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => sendAction('in')}
              {...dataProps}
            >
              <LinkedInIcon />
            </a>
          </div>
          <div className={styles.linkHolder}>
            <a
              className={styles.link}
              href="https://www.facebook.com/flatfy"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => sendAction('fb')}
              {...dataProps}
            >
              <FacebookIcon />
            </a>
          </div>
        </div>
      )}
    </AnalyticsConsumer>
  </section>
);

export default FollowUs;
